<div class="page-container report-results">
  <app-card>
    <app-card-header>
      <app-card-title>
        <div class="header-row flex flex-wrap flex-align-center flex-justify-space-between gap-sm">
          <h2 data-testid="report-results-heading">
            {{ reportName() || ('reports.results.title' | translate) }}
          </h2>
          <div class="result-actions flex flex-wrap gap-sm no-print">
            @if (canSaveAs()) {
            <app-button variant="text" (click)="saveAs()" [disabled]="saving()"
              *hasPermission="'reports.create'" data-testid="save-report-as-button">
              <app-icon name="copy" />
              {{ 'reports.results.saveAs' | translate }}
            </app-button>
            }
            <app-button variant="outlined" (click)="save()" [disabled]="!canSave() || saving()"
              *hasPermission="'reports.create'" data-testid="save-report-button">
              <app-icon name="save" />
              {{ (isSaved() ? 'reports.results.update' : 'reports.results.save') | translate }}
            </app-button>
            <app-button variant="outlined" (click)="exportCsv()" [disabled]="!hasRows()"
              data-testid="export-csv-button">
              <app-icon name="download" />
              {{ 'reports.results.exportCsv' | translate }}
            </app-button>
            <app-button variant="outlined" (click)="exportXlsx()" [disabled]="!hasRows()"
              data-testid="export-xlsx-button">
              <app-icon name="download" />
              {{ 'reports.results.exportXlsx' | translate }}
            </app-button>
            <app-button variant="outlined" (click)="print()" [disabled]="!hasRows()"
              data-testid="print-button">
              <app-icon name="printer" />
              {{ 'reports.results.print' | translate }}
            </app-button>
          </div>
        </div>
      </app-card-title>
    </app-card-header>

    <app-card-content>
      @if (loading()) {
      <div class="loading-container flex flex-column flex-align-center gap-md p-lg" data-testid="report-loading">
        <app-spinner />
        <p>{{ 'reports.results.running' | translate }}</p>
      </div>
      } @else if (error()) {
      <div class="error-banner flex flex-align-center gap-md p-md" data-testid="report-error">
        <app-icon name="alert-circle" />
        <p>{{ error() }}</p>
      </div>
      } @else if (result(); as res) {
      <!-- Summary bar -->
      <div class="summary-bar flex flex-align-center flex-wrap gap-lg" data-testid="report-summary">
        <div class="summary-metric">
          <span class="summary-label">{{ 'reports.results.rowCount' | translate }}</span>
          <span class="summary-value" data-testid="summary-row-count">{{ res.summary.rowCount }}</span>
        </div>
        @if (isAggregate() && res.summary.aggregateValue != null) {
        <div class="summary-metric">
          <span class="summary-label">{{ res.columns[0].label }}</span>
          <span class="summary-value" data-testid="summary-aggregate">{{ res.summary.aggregateValue }}</span>
        </div>
        }

        @if (criteria(); as c) {
        <div class="summary-criteria" data-testid="report-criteria">
          <div class="criteria-line" data-testid="criteria-form">
            {{ 'reports.builder.summary.form' | translate }}: {{ c.formLabel }}
          </div>
          <div class="criteria-line" data-testid="criteria-time-range">
            {{ 'reports.builder.summary.timeRange' | translate }}: {{ c.timeRangeLabel }}
          </div>
          @for (line of c.filterLines; track line) {
          <div class="criteria-line" data-testid="criteria-filter">{{ line }}</div>
          }
          @if (c.latestPerInstanceLine) {
          <div class="criteria-line" data-testid="criteria-latest-per-instance">
            {{ c.latestPerInstanceLine }}
          </div>
          }
          @if (c.asOfLine) {
          <div class="criteria-line" data-testid="criteria-as-of">{{ c.asOfLine }}</div>
          }
          <div class="criteria-line" data-testid="criteria-aggregation">
            {{ 'reports.builder.summary.aggregation' | translate }}: {{ c.aggregationLabel
            }}{{ c.groupByLabel ? ', ' + c.groupByLabel : '' }}
          </div>
        </div>
        }
      </div>

      @if (hasRows()) {
      <div class="table-wrapper">
        <table class="results-table" data-testid="report-table">
          <thead>
            <tr>
              @for (col of res.columns; track col.key) {
              <th>{{ col.label }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of res.rows; track $index) {
            <tr>
              @for (col of res.columns; track col.key) {
              <td>{{ row[col.key] }}</td>
              }
            </tr>
            }
          </tbody>
        </table>
      </div>
      } @else {
      <div class="empty-state flex flex-column flex-align-center gap-sm p-lg" data-testid="report-empty">
        <app-icon name="inbox" [size]="32" />
        <p>{{ 'reports.results.noRows' | translate }}</p>
      </div>
      }
      }
    </app-card-content>

    <!-- Navigation -->
    <app-card-actions class="no-print">
      <app-button variant="text" (click)="back()" data-testid="report-results-back-button">
        <app-icon name="arrow-left" />
        {{ 'reports.results.back' | translate }}
      </app-button>
      <span class="flex-grow"></span>
      <app-button variant="outlined" (click)="editReport()" data-testid="report-results-edit-button">
        <app-icon name="settings" />
        {{ 'reports.results.edit' | translate }}
      </app-button>
    </app-card-actions>
  </app-card>
</div>
